import { takeLatest } from 'redux-saga/effects';
import { TICKET_INSERTED } from '../features/queues';
import { AppSettings, getAppSettings } from '../utils/storage';
// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
import doorBell from '../assets/sounds/doorBell.wav';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const sounds: any = {
  doorBell
};

function playSound(name: string) {
  const soundFile = sounds[name] || doorBell;
  const audio = new window.Audio(soundFile);

  audio.play();
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* ticketInserted(action: any) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { queue, newTicket } = action;
  const settings: AppSettings = yield getAppSettings();
  switch (settings.notifications) {
    case 'off': {
      // Do nothing
      break;
    }
    case 'sound.doorBell': {
      playSound('doorBell');
      break;
    }
  }
}

export function* ticketChangesSaga() {
  yield takeLatest(TICKET_INSERTED, ticketInserted);
}
